module.exports = __webpack_public_path__ + "odstraneni-tetovaze_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_2_before.jpg
// module id = 956
// module chunks = 0